<template>
  <SidebarCheckboxList
    v-if="filteredSorts.length"
    :title="$t('Grade')"
    :search-value="searchValue"
    :items="filteredSorts"
    :items-selected="sortsSelected"
    @search-input="searchValue = $event"
    @select="select"
  >
    <template #label="{ item }">
      <span>{{ item.name }}</span>
    </template>
  </SidebarCheckboxList>
</template>

<script>
import { mapState } from 'vuex'
import SidebarCheckboxList from '@/components/filters/sidebar/SidebarCheckboxList.vue'

export default {
  name: 'GradeFilter',
  components: {
    SidebarCheckboxList,
  },
  data: () => {
    return {
      searchValue: '',
    }
  },
  computed: {
    ...mapState('product', ['products', 'sorts']),
    ...mapState('filtration', ['sortsSelected']),
    ...mapState('marketCatalog', ['filterMetadata']),
    filteredSorts() {
      const productSortsSet = new Set((this.filterMetadata?.sorts || []).map(s => s.id))

      if (this.currentProduct) {
        return this.currentProduct.sort.filter(s => productSortsSet.has(s.id))
      }

      return this.sorts.filter(s => productSortsSet.has(s.id))
    },
    currentProduct() {
      return this.products.find(p => p.routeName === this.$route.params.productName)
    },
  },
  watch: {
    currentProduct() {
      this.searchValue = ''
    },
  },
  methods: {
    select(sort) {
      if (this.sortsSelected.some(s => s.id === sort.id)) {
        this.$store.dispatch(
          'filtration/setProductSortsSelected',
          this.sortsSelected.filter(s => s.id !== sort.id),
        )
      } else {
        this.$store.dispatch('filtration/setProductSortsSelected', [...this.sortsSelected, sort])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.grade-filter {
}
</style>
